/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { StackDeployment } from './types'

/**
 * Extracts the Elasticsearch version from a deployment
 * @param deployment - The deployment object
 * @returns The version string (e.g., "9.3.2") or null if not found
 */
export const getElasticsearchVersion = (deployment: StackDeployment): string | null => {
  if (!deployment) {
    return null
  }

  // Try to get version from the first Elasticsearch resource
  const esResource = deployment.resources?.elasticsearch?.[0]
  const version = esResource?.info?.plan_info?.current?.plan?.elasticsearch?.version

  return version || null
}
